module.exports = __webpack_public_path__ + "img/LDSJ_STILL28.cfe268fa.jpg";